import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class articlesView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="w-form w-form-large">
                
                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>     
                        <button data-bind="event: { click: onClickEdit   }, visible: (permissions()['article_edit_brand'].write) || (permissions()['article_edit_self'].write && articleAuthorId() == idLoggedUser())" class="btn icon i-edit" type="button">Edit Article</button>
                    </div>
                    
                    <div class="w-form-body">
                    
                        
                        <div class="form-body">
                            <strong class="form-sub-title icon i-article">General Info</strong>
                            
                            <div class="form-group">
                                <strong class="form-content-title"  data-bind="text: title"></strong>
                                <span class="status-label">published on<span class="icon i-calendar-b" data-bind="text: datePublished"></span></span>
                            </div>

                            <div class="form-group">
                                <dl class="double-list">
                                
                                    <dt>
                                        <span>Emaki post ID</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: id"></span>
                                    </dd>
                                    <dt>
                                        <span>WP post ID</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: reference"></span>
                                    </dd>
                                    <dt class="full-width">
                                        <span>Permalink</span>
                                    </dt>
                                    <dd class="full-width">
                                        <span style="text-transform: none"  data-bind="text: permalink"></span>
                                    </dd>  
                                    
                                    <dt>
                                        <span>Publish Status</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: publishStatus"></span>
                                    </dd>                                
                                   
                                </dl>
                            </div>
                            <strong class="form-sub-title icon i-user">Users</strong>
                            <div class="form-group">
                                <dl class="double-list">                                                                      
                                    
                                    <dt>
                                        <span>Sr Editor</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: editor"></span>
                                    </dd>
                                    <dt>
                                        <span>Jr Editor</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: jrEditor"></span>
                                    </dd>
                                    <dt>
                                        <span >Author</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: author"></span>
                                    </dd>
                                    <dt>
                                        <span >Display Author</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: displayAuthor"></span>
                                    </dd>
                                                                    
                                </dl>
                            </div>
                            <strong class="form-sub-title icon i-payment">Payment</strong>
                            <div class="form-group">
                                <dl class="double-list">                                                                    
                                    <dt>
                                        <span>Payment Category</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: postPaymentCategory"></span>
                                    </dd>
                                </dl>
                                </dl>
                            </div>
                            <strong class="form-sub-title icon i-settings">Settings</strong>
                            
                            <div class="form-group">
                                <dl class="double-list">
                                    
                                    <dt>
                                        <span>Target Audience</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: targetAudience"></span>
                                    </dd>
                                    <dt>
                                        <span>Intent</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: intent"></span>
                                    </dd>
                                    <dt>
                                        <span>Content Type</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: contentType"></span>
                                    </dd>
                                    <dt>
                                        <span>Network Category</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: networkCategory"></span>
                                    </dd>

                                </dl>
                            </div>
                            
                            
                            <strong class="form-sub-title icon i-article">Amazon Onsite</strong>
                            <div class="form-group">
                                <dl class="double-list">                                                      
                                    <dt>
                                        <span>On site article title</span>
                                    </dt>                                    
                                    <dd>
                                        <span data-bind="text: amazonsiteArticleTitle"></span>                                        
                                    </dd>
                                    
                                     <dt>
                                        <span>On site published date</span>
                                    </dt>    
                                    <dd>
                                         <span data-bind="text: amazonsitePublishDate"></span>    
                                    </dd>                                                                                                                                                                     
                                </dl>
                            </div>    
                                    
                        </div>
                            
                        
                        <div class="form-body">
                            <strong class="form-sub-title icon i-redo">Republish History</strong>
                         
                            <div class="w-form-group" data-bind="foreach: republishes">
                                <div class="form-group-header">
                                    <div>
                                        <span>Republish date</span>
                                        <strong data-bind="text: dateRepublished.substring(0, 10)"></strong>
                                    </div>
                                    <div>
                                        <span>Republish Status</span>
                                        <strong data-bind="text: publishStatus.name"></strong>
                                    </div>
                                    <div>
                                        <span>Republish by</span>
                                        <strong data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></strong>
                                    </div>
                                </div>
                                <div class="form-group">
                                    
                                    <dl class="double-list">
                                       
                                        <dt>
                                            <span>Author</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Payment Category</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: postPaymentCategory"><span data-bind="text: postPaymentCategory.name"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Sr Editor</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: editor"><span data-bind="text: editor.valnet_user.fullName"></span></span>
                                        </dd>
                                        <dt>
                                            <span>Jr Editor</span>
                                        </dt>
                                        <dd>
                                            <span data-bind="if: juniorEditor"><span data-bind="text: juniorEditor.valnet_user.fullName"></span></span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>           
                        </div>
                           
                    </div>
                           
             
                </div>
 
                `;
    }

    protected initPartial(): void{

    }

    protected getTemplateName(): string{

        return "articlesView_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
              id: ko.observable("")
            , title: ko.observable("")
            , reference: ko.observable("")
            , editor: ko.observable("")
            , datePublished: ko.observable("")
            , author: ko.observable("")
            , articleAuthorId: ko.observable("")
            , displayAuthor: ko.observable("")
            , jrEditor: ko.observable("")
            , targetAudience: ko.observable("")
            , intent: ko.observable("")
            , contentType: ko.observable("")
            , networkCategory: ko.observable("")
            , postPaymentCategory: ko.observable("")
            , permalink: ko.observable("")
            , republishes: ko.observableArray([])
            , isEditShown: ko.observable(false)
            , publishStatus: ko.observable("")
            , amazonsiteArticleTitle: ko.observable("")
            , amazonsitePublishDate: ko.observable("")
            , idLoggedUser: ko.observable("")
            , permissions: ko.observableArray(this.initPermissions(['article_edit_self', 'article_edit_brand']))
            , onClickEdit: function (data){
                huit_neuf_this.onClickEdit(data.id());
            }
            , onClickCancel: function (data, event){
                huit_neuf_this.onClickCancel();
            }
        }
    }

    public onClickEdit(id){

        this.caller.editArticle(id);
    }

    protected onClickCancel(){

        this.caller.goBackToViewArticle();
    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setTitle(title): void{

        this.getTemplateViewModel().title(title);
    }

    public setReference(reference): void{

        this.getTemplateViewModel().reference(reference);
    }

    public setEditor(editor): void{

        this.getTemplateViewModel().editor(editor);
    }

    public setDatePublished(datePublished): void{

        this.getTemplateViewModel().datePublished(datePublished);
    }

    public setAuthor(author): void{

        this.getTemplateViewModel().author(author);
    }

    public setAuthorId(authorId): void{

        this.getTemplateViewModel().articleAuthorId(authorId);
    }

    public setDisplayAuthor(displayAuthor): void{

        this.getTemplateViewModel().displayAuthor(displayAuthor);
    }

    public setJrEditor(jrEditor): void{

        this.getTemplateViewModel().jrEditor(jrEditor);
    }

    public setTargetAudience(targetAudience): void{

        this.getTemplateViewModel().targetAudience(targetAudience);
    }

    public setIntent(intent): void{

        this.getTemplateViewModel().intent(intent);
    }

    public setContentType(contentType): void{

        this.getTemplateViewModel().contentType(contentType);
    }

    public setPermalink(permalink): void{

        this.getTemplateViewModel().permalink(permalink);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory);
    }

    public setPostPaymentCategory(postPaymentCategory): void{

        this.getTemplateViewModel().postPaymentCategory(postPaymentCategory);
    }

    public setArticleRepublishData(republishes: Array<{}>): void{

        this.getTemplateViewModel().republishes(republishes);
    }

    public setIsEditShown(isEditShown): void{

        this.getTemplateViewModel().isEditShown(isEditShown);
    }

    public setPublishStatus(publishStatus): void{

        this.getTemplateViewModel().publishStatus(publishStatus);
    }

    public setAmazonsiteArticleTitle(amazonsiteArticleTitle): void{

        if(amazonsiteArticleTitle) {

            this.getTemplateViewModel().amazonsiteArticleTitle(amazonsiteArticleTitle);
        }else{

            this.getTemplateViewModel().amazonsiteArticleTitle(this.getTemplateViewModel().title());
        }
    }

    public setAmazonsitePublishDate(amazonsitePublishDate): void{

        if(amazonsitePublishDate) {

            this.getTemplateViewModel().amazonsitePublishDate(amazonsitePublishDate);
        }else{

            this.getTemplateViewModel().amazonsitePublishDate(this.getTemplateViewModel().datePublished());
        }
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setIdLoggedUser(idLoggedUser): void{

        this.getTemplateViewModel().idLoggedUser(idLoggedUser);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articlesView_template.ts